import Config from "../../../Config";
import Temperature from "../channels/Temperature";
import Humidity from "../channels/Humidity";
import WetTemperature from "../channels/WetTemperature";
import HumidityDay from "../channels/HumidityDay";
import TemperatureDay from "../channels/TemperatureDay";
import WetTemperatureDay from "../channels/WetTemperatureDay";
import Asparagus1 from "../channels/Asparagus1";
import Asparagus2 from "../channels/Asparagus2";
import Asparagus3 from "../channels/Asparagus3";
import Asparagus4 from "../channels/Asparagus4";
import AsparagusDay1 from "../channels/AsparagusDay1";
import AsparagusDay2 from "../channels/AsparagusDay2";
import AsparagusDay3 from "../channels/AsparagusDay3";
import AsparagusDay4 from "../channels/AsparagusDay4";
import MilkTemp1 from "../channels/MilkTemp1";
import MilkTemp2 from "../channels/MilkTemp2";
import MilkTemp3 from "../channels/MilkTemp3";
import MilkTemp4 from "../channels/MilkTemp4";
import MilkTemp5 from "../channels/MilkTemp5";
import MilkTemp6 from "../channels/MilkTemp6";
import MilkTemp7 from "../channels/MilkTemp7";
import MilkTemp0 from "../channels/MilkTemp0";
import MilkTempDay1 from "../channels/MilkTempDay1";
import MilkTempDay2 from "../channels/MilkTempDay2";
import MilkTempDay3 from "../channels/MilkTempDay3";
import MilkTempDay4 from "../channels/MilkTempDay4";
import MilkTempDay5 from "../channels/MilkTempDay5";
import MilkTempDay6 from "../channels/MilkTempDay6";
import MilkTempDay7 from "../channels/MilkTempDay7";
import MoistureDay from "../channels/MoistureDay";
import Moisture from "../channels/Moisture";
import MilkLightRed from "../channels/MilkLightRed";
import WeatherTemp from "../channels/WeatherTemp";
import WeatherHumidity from "../channels/WeatherHumidity";
import WeatherClouds from "../channels/WeatherClouds";
import WeatherWindSpeed from "../channels/WeatherWindSpeed";
import DeviceTemperature from "../channels/DeviceTemperature";
import DeviceVoltage from "../channels/DeviceVoltage";
import ConnectionMinVoltage from "../channels/ConnectionMinVoltage";
import ConnectionSignalStrength from "../channels/ConnectionSignalStrength";
import ConnectionTime from "../channels/ConnectionTime";
import LocationNotification from "../channels/LocationNotification";
import LeafSensorPressure from "../channels/LeafSensorPressure";
import LeafSensorTemperature from "../channels/LeafSensorTemperature";
import MoistureRaw from "../channels/MoistureRaw";
import LeafSensorPressureAvg from "../channels/LeafSensorPressureAvg"
import Weather from "../channels/Weather";
import LeafPressureRegressionMorning from "../channels/LeafPressureRegressionMorning";
import LeafPressureRegressionAfternoon from "../channels/LeafPressureRegressionAfternoon";
import LeafHydricState from "../channels/LeafHydricState";
import LeafSensorTemperatureAvg from "../channels/LeafSensorTemperatureAvg";
import SoilStickMoisture from "../channels/SoilStickMoisture";
import SoilStickMoisture2 from "../channels/SoilStickMoisture2";
import SoilStickHumidity from "../channels/SoilStickHumidity";
import SoilStickTemperature from "../channels/SoilStickTemperature";
import SoilStickTemperature2 from "../channels/SoilStickTemperature2";
import SoilStickMoistureVwc from "../channels/SoilStickMoistureVwc";
import SoilStickMoisturePercent from "../channels/SoilStickMoisturePercent";
import SoilStickMoisture2Vwc from "../channels/SoilStickMoisture2Vwc";
import AsparagusSum from "../channels/AsparagusSum";
import ValueEvent from "../channels/ValueEvent";

let channelTemplates = {

    /**Field Monitoring*/
    "hm": Humidity,
    "ht": Temperature,
    "wt": WetTemperature,
    "hd": HumidityDay,
    "htd": TemperatureDay,
    "wtd": WetTemperatureDay,
    "mo": Moisture,
    "mor": MoistureRaw,
    "mod": MoistureDay,

    /**Asparagus*/
    "at1": Asparagus1,
    "adt1": AsparagusDay1,
    "at2": Asparagus2,
    "adt2": AsparagusDay2,
    "at3": Asparagus3,
    "adt3": AsparagusDay3,
    "at4": Asparagus4,
    "adt4": AsparagusDay4,
    "ads": AsparagusSum,

    /**Milk Monitoring*/
    "mto": MilkTemp0,
    "mt1": MilkTemp1,
    "mt2": MilkTemp2,
    "mt3": MilkTemp3,
    "mt4": MilkTemp4,
    "mt5": MilkTemp5,
    "mt6": MilkTemp6,
    "mt7": MilkTemp7,

    "mdt1": MilkTempDay1,
    "mdt2": MilkTempDay2,
    "mdt3": MilkTempDay3,
    "mdt4": MilkTempDay4,
    "mdt5": MilkTempDay5,
    "mdt6": MilkTempDay6,
    "mdt7": MilkTempDay7,

    "mrl": MilkLightRed,

    /**Weather*/
    "wpt": WeatherTemp,
    "wph": WeatherHumidity,
    "wpcl": WeatherClouds,
    "wpws": WeatherWindSpeed,
    "wic": Weather,

    /**Device*/
    "dt": DeviceTemperature,
    "dv": DeviceVoltage,

    /**Connection*/
    "css": ConnectionSignalStrength,
    "cmv": ConnectionMinVoltage,
    "ct": ConnectionTime,

    "ln": LocationNotification,

    "ve": ValueEvent,

    /**Smart Irrigation*/
    "lep": LeafSensorPressure,
    "lepa": LeafSensorPressureAvg,
    "let": LeafSensorTemperature,
    "leta": LeafSensorTemperatureAvg,
    "lprm": LeafPressureRegressionMorning,
    "lpra": LeafPressureRegressionAfternoon,
    "lhs": LeafHydricState,

    /**Soil stick*/
    "ssm": SoilStickMoisture,
    "ssmv": SoilStickMoistureVwc,
    "ssmp": SoilStickMoisturePercent,
    "ssm2": SoilStickMoisture2,
    "ssm2v": SoilStickMoisture2Vwc,
    "ssh": SoilStickHumidity,
    "sst": SoilStickTemperature,
    "sst2": SoilStickTemperature2
};

let style = {
    "line": {
        pointStyle: "circle",
        pointBorderWidth: 2,
        borderWidth: 1,
        fill: true,
        lineTension: 0,
        animation: {
            duration: 0,
            easing: "linear"
        }
    },
    "bar": {
        fill: true,
        borderWidth: 2,
        // maxBarThickness: 20,
        scaleBeginAtZero: false
    }
};

export default class ChartDataParser {
    static parse(data, channels, labelPrefix = "", noFill = false, ret = null, indexed = false, indexLabels = null) {
        ret = ret || {
            labels: [],
            datasets: []
        };

        /**protection for doubled labels*/
        if (!ret.hasOwnProperty("labelIndex")) {
            ret.labelIndex = {};
        }

        /**check for bindings to other channels*/
        let bindings = this.getBindings(channels);

        /**process channels*/
        let channelIndex = channels.split(",");

        let dataSets = {};
        for (let time in data) {
            let d = data[time];

            /**attention: on indexed charts we can not just use push, since labels might already exist*/
            if (!ret.labelIndex.hasOwnProperty(time)) {
                ret.labels.push(time);
                ret.labelIndex[time] = true;
            }

            let i = ret.datasets.length;
            let fill = !noFill;
            let j = 0;
            for (let channel in d) {
                if (!dataSets.hasOwnProperty(channel)) {
                    let template = null;

                    /**is there a binding to another output channel?*/
                    if (bindings.hasOwnProperty(channel) &&
                        undefined !== bindings[channel]) {
                        let bind = bindings[channel];

                        template = Object.assign(channelTemplates[channel], channelTemplates[bind]);

                        /**if new channel has no label, take old one*/
                        if (template.hasOwnProperty("label") === false || null === template.label) {
                            template.label = channelTemplates[channel].label;
                        }

                    /**is there a mapping from channel to object?*/
                    } else if (channelTemplates.hasOwnProperty(channel)) {
                        //console.log("Template: " + channel);
                        template = channelTemplates[channel];
                    }

                    /**channel found*/
                    if (template) {
                        let dataSet = Object.assign({data: []}, template);

                        /**Channel e.g. = ht, search for ht:1233 in channelIndex*/
                        let cKey = null;
                        for (let cI in channelIndex) {
                            let cIp = channelIndex[cI].split(":");
                            if (cIp[0] === channel) {
                                cKey = channelIndex[cI];
                            }
                        }

                        /**Now search for the key ht:1233 in Labels*/
                        if (indexLabels && indexLabels.hasOwnProperty(cKey)) {
                            dataSet["label"] = indexLabels[cKey];
                        }

                        /**color palette defined by channel OR if indexed by count*/
                        let col = (template.hasOwnProperty('colorPalette') ? template["colorPalette"] : i);
                        if (true === indexed) {
                            col = i;
                        }
                        dataSet = this.setColor(dataSet, col, fill);

                        /**area fil*/
                        if (template.fill) {
                            fill = false;
                        }
                        dataSet["channel"] = channel;
                        dataSets[channel] = dataSet;
                        dataSet.label = (labelPrefix.length ? labelPrefix : dataSet.label);

                        ret.datasets.push(dataSet);
                    }
                }

                if (dataSets.hasOwnProperty(channel)) {
                    let dataSet = dataSets[channel];
                    let channelValue = d[channel];

                    /**array of values for scatter*/
                    if (Array.isArray(channelValue)) {
                        for (let v in channelValue) {
                            dataSet.data.push({"x": time, "y": channelValue[v]});
                        }
                    /**simple values, e.g. int, float etc, or objects for plugins which are transformed by channel*/
                    } else {
                        /**transform datapoint by channel*/
                        let v = dataSet.hasOwnProperty("dataTransformCallback") ? dataSet.dataTransformCallback(time, channelValue, dataSets) : channelValue;

                        /**also include null values to include data gaps*/
                        if (dataSet.xAxis.type === "time") {
                            if (null !== v) {
                                dataSet.data.push({"x": moment(time, 'YYYY-MM-DD HH:mm:ss').toDate(), "y": v, "v": channelValue});
                            }
                        } else {
                            if (null !== v) {
                                dataSet.data.push({"x": time, "y": v, "v": channelValue});
                            }
                        }
                    }
                }

                i++;
                j++;
            }
        }

        ret.labels.sort();

        return ret;
    }

    static parseIndexed(data, channels, labels) {
        let ret = {
            labels: [],
            datasets: []
        };

        /**channel:id => label*/
        let i=0;
        /*channelRef = channel:id*/
        let channelRef = channels.split(",");

        /**index = id */
        for (let index in data) {

            /*channel id string*/
            let cNames = channelRef[i].split(':');
            let cName = cNames[0]+":"+index;

            /*remove time shift*/
            if (cName.indexOf("~")>0) {
                let cNameComp = cName.split("~");
                cName = cNameComp[0];
            }

            ChartDataParser.parse(data[index], channels, (labels[cName] || ""), true, ret, true);
            i++;
        }

        this.fixIndexedDatasetValues(ret);

        return ret;
    }

    static fixIndexedDatasetValues(config) {
        if (config.labels.length <= 1) return;
        for (let dataset of config.datasets) {
            if (dataset.data.length > 1) return;
        }

        for (let dataset of config.datasets) {
            if (dataset.data.length > 1) continue;

            let index = dataset.data[0].x;
            let newData = [];

            for (let label of config.labels) {
                if (label !== index) {
                    newData.push({x: label, y: null});
                } else {
                    newData.push(dataset.data[0]);
                }
            }

            dataset.data = newData;
            dataset.stack = "stack1";
        }
    }

    /**
     *
     * @param {object} template
     * @param {number} index
     * @param {boolean} fill
     * @returns {*}
     */
    static setColor(template, index, fill) {
        let color = Config.colorPalette[index % Config.colorPalette.length];

        if (template.type === "line") {
            /*create template based on generic styles*/
            let tpl = Object.assign({}, style["line"]);

            /*copy channel template and overwrite default styles*/
            template = Object.assign(tpl, template);

            if (!template.hasOwnProperty("pointBorderColor")) {
                template.pointBorderColor = color["stroke"];

                if (!template.hasOwnProperty("pointBackgroundColor")) {
                    template.pointBackgroundColor = "#fff";
                }
            }

            if (!template.hasOwnProperty("background")) {
                template.backgroundColor = color["backgroundLight"];
            }

            if (!template.hasOwnProperty("borderColor")) {
                template.borderColor = color["stroke"];
            }
            template.pointHoverBackgroundColor = "white";

        } else if (template.type === "bar") {
            template = Object.assign({}, template, style["bar"]);

            if (!template.hasOwnProperty("fillColor")) {
                template.fillColor = color["backgroundLight"];
            }
            if (!template.hasOwnProperty("strokeColor")) {
                template.strokeColor = color["stroke"];
            }
            if (!template.hasOwnProperty("backgroundColor")) {
                template.backgroundColor = color["backgroundLight"];
            }
            if (!template.hasOwnProperty("borderColor")) {
                template.borderColor = color["stroke"];
            }
            if (!template.hasOwnProperty("highlightFill")) {
                template.highlightFill = color["background"];
            }
            if (!template.hasOwnProperty("highlightStroke")) {
                template.highlightStroke = color["stroke"];
            }
        }

        template.fill = template.fill && fill;

        return template;
    }

    /**
     * Extract output bindings from channels
     * Attention: channels separated by ",", ids separated by ":" and time shift separated by "~" - binding separation by ">"
     *
     * @param channels
     * @returns {{}}
     */
    static getBindings(channels) {
        let bindings = {};

        let arr = channels.split(",");
        for (let i in arr) {
            /*channel is binded to another*/
            if (arr[i].indexOf(">")) {
                /*split channel:id from >binding*/
                let parts = arr[i].split(">");

                /*also: split by id and other extensions*/
                let subpart = parts[0].split(":");

                /*use only channel name without any additions*/
                bindings[subpart[0]] = parts[1];
            }
        }
        return bindings;
    }
}



// WEBPACK FOOTER //
// ./src/components/chart/data/ChartDataParser.js